import React, { useEffect, useState } from 'react'

import { type MetalTier } from '../prospects/types'

export function MetalTierBadge ({ type }: { type: MetalTier }) {
  const [label, setLabel] = useState('Unknown')
  const [classes, setClasses] = useState('bg-gray-100 text-gray-800')

  useEffect(() => {
    switch (type) {
      case 'bronze':
      case 'expanded_bronze':
        setClasses('bg-orange-100 text-orange-600')
        setLabel('Bronze')
        break
      case 'silver':
        setClasses('bg-gray-100 text-gray-800')
        setLabel('Silver')
        break
      case 'gold':
        setClasses('bg-yellow-100 text-yellow-600')
        setLabel('Gold')
        break
      case 'platinum':
        setClasses('bg-slate-100 text-slate-600')
        setLabel('Platinum')
        break
      default:
        setClasses('bg-gray-100 text-gray-800')
        setLabel('Unknown')
    }
  }, [type])

  return (
    <span
      className={`inline-flex items-center rounded-[8px] px-2 py-1 text-xs leading-[18px] font-semibold ${classes}`}
    >
      {label}
    </span>
  )
}
